/*----------------------------------
- DOMAINING NEWS GATEWAY CONTRACT
----------------------------------*/

export const DOMAINING_NEWS_ARCHIVE_GATEWAY_PATH =
    '/api/website/domaining-news/list-published';
export const DOMAINING_NEWS_EDITION_GATEWAY_PATH =
    '/api/website/domaining-news/get-published';
/**
 * Full payload of the latest published edition, used by the archive lead card.
 * It resolves its own date key, so the archive never has to chain two reads.
 */
export const DOMAINING_NEWS_LEAD_EDITION_GATEWAY_PATH =
    '/api/website/domaining-news/lead-edition';
